<net-opportunity-form mode="dialog" [loading]="loading" [opportunity]="opportunity" [account]="account"
  (save)="onSave($event)" (emitMailRequest)="mailRequest = $event" (isFormChange)="onFormChanged($event)"
  [formChanged]="formChanged"
  [closeOpportunityFormDialog]="closeOpportunityFormDialog.bind(this)"></net-opportunity-form>